import { render } from "./infosCardServicos.vue?vue&type=template&id=1a7a3cf2&scoped=true"
import script from "./infosCardServicos.vue?vue&type=script&lang=js"
export * from "./infosCardServicos.vue?vue&type=script&lang=js"

import "./infosCardServicos.vue?vue&type=style&index=0&id=1a7a3cf2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7a3cf2"]])

export default __exports__